<script lang="ts">
    import { twMerge } from 'tailwind-merge';
    import { iconClasses } from './icon-settings';

    let className = '';
    export { className as class };
</script>

<svg
    class={twMerge(iconClasses, className)}
    xmlns="http://www.w3.org/2000/svg"
    width="23.978"
    height="24"
    viewBox="0 0 23.978 24">
    <path
        d="M64.934,292.736H59.469l6.7-6.706-6.641-6.706h5.466l6.7,6.706Zm0-18.706a12,12,0,1,0,11.989,12,11.969,11.969,0,0,0-11.989-12"
        transform="translate(-52.945 -274.03)"
        fill="currentColor" />
</svg>
